import { Card, Muted, Row, Small } from '@widgets/ksp-workspace/parts';
import { RUN_STATUS } from '../types';

export interface RdSummaryCardProps {
  timezone: string;
  run?: {
    status: string;
    system?: boolean;
    created_at: string;
    error?: string | null;
  } | null;
  isFetching: boolean;
}

export function RdSummaryCard({ timezone, run, isFetching }: RdSummaryCardProps) {
  return (
    <Card>
      <h3>Даты выдачи РД и автоматический пересчёт</h3>
      <Muted>
        Работа не начинается раньше готовности обязательной РД: наиболее поздней из подтверждённых
        инженером дат получения и разрешения к производству по каждому обязательному комплекту.
        Дата без времени — с начала суток в поясе проекта ({timezone}), дальше первый рабочий
        интервал календаря работы. Кандидаты ПТО (дата загрузки ревизии, штамп «В производство
        работ») сами прогноз не меняют. Без подтверждённой даты прогноз условный по плановой
        выдаче, без неё — не определён.
      </Muted>
      <Row>
        <Small>
          {run
            ? `${RUN_STATUS[run.status] ?? run.status}${run.system ? ' (системный)' : ''} · ${new Date(run.created_at).toLocaleString('ru-RU')}${run.error ? ` · ${run.error}` : ''}`
            : 'Расчётов ещё не было'}
        </Small>
        {isFetching && <Small>обновление…</Small>}
      </Row>
    </Card>
  );
}
